/**
 * @flow
 * @relayHash da5d984378ccc8e8ea7d00b1c9371ecf
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type RecoverVerifyByEmailFormMutationVariables = {|
  email: string,
  code: string,
|};
export type RecoverVerifyByEmailFormMutationResponse = {|
  +forgot_password_verify_code: ?{|
    +errors: ?$ReadOnlyArray<?{|
      +field: ?string,
      +messages: ?$ReadOnlyArray<?string>,
      +code: ?number,
    |}>,
    +message: ?string,
  |}
|};
export type RecoverVerifyByEmailFormMutation = {|
  variables: RecoverVerifyByEmailFormMutationVariables,
  response: RecoverVerifyByEmailFormMutationResponse,
|};
*/


/*
mutation RecoverVerifyByEmailFormMutation(
  $email: String!
  $code: String!
) {
  forgot_password_verify_code(email: $email, code: $code) {
    errors {
      field
      messages
      code
    }
    message
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "email",
    "type": "String!",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "code",
    "type": "String!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "forgot_password_verify_code",
    "storageKey": null,
    "args": [
      {
        "kind": "Variable",
        "name": "code",
        "variableName": "code",
        "type": "String"
      },
      {
        "kind": "Variable",
        "name": "email",
        "variableName": "email",
        "type": "String"
      }
    ],
    "concreteType": "ForgotPassword",
    "plural": false,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "errors",
        "storageKey": null,
        "args": null,
        "concreteType": "Error",
        "plural": true,
        "selections": [
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "field",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "messages",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "code",
            "args": null,
            "storageKey": null
          }
        ]
      },
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "message",
        "args": null,
        "storageKey": null
      }
    ]
  }
];
return {
  "kind": "Request",
  "operationKind": "mutation",
  "name": "RecoverVerifyByEmailFormMutation",
  "id": null,
  "text": "mutation RecoverVerifyByEmailFormMutation(\n  $email: String!\n  $code: String!\n) {\n  forgot_password_verify_code(email: $email, code: $code) {\n    errors {\n      field\n      messages\n      code\n    }\n    message\n  }\n}\n",
  "metadata": {},
  "fragment": {
    "kind": "Fragment",
    "name": "RecoverVerifyByEmailFormMutation",
    "type": "Mutation",
    "metadata": null,
    "argumentDefinitions": v0,
    "selections": v1
  },
  "operation": {
    "kind": "Operation",
    "name": "RecoverVerifyByEmailFormMutation",
    "argumentDefinitions": v0,
    "selections": v1
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'f9064a1404e90943c286c5289d17433a';
module.exports = node;
